import {
  CButton,
  CCardFooter,
  CCol,
  CForm,
  CFormInput,
  CFormSelect,
  CRow,
  CSmartPagination,
} from '@coreui/react-pro'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { SEARCH_LIMIT, SETTINGS_CODE } from 'src/constants/Constants'
import { handleIntegerPressDown } from 'src/utils/helpers'

const TableFooter = (props) => {
  const {
    data,
    onActivePageChange,
    hideDisplaySummary,
    hideJumpToPage,
    sizeSM,
    searchParams,
    handlePerPageChange,
    isLoading = false,
  } = props
  const { t } = useTranslation('common')
  const [currentPage, setCurrentPage] = useState(data?.current_page ?? 1)

  const settings = useSelector((state) => state.settings?.settings)

  const pageLimitOptions = useMemo(() => {
    const perPageSetting = settings.find(
      (setting) => setting.code === SETTINGS_CODE.PER_PAGE,
    )?.value
    const { min, max } = JSON.parse(perPageSetting || '{}')
    const options = min && max ? SEARCH_LIMIT.filter((x) => x < max && x > min) : SEARCH_LIMIT
    return [min, ...options, max]
  }, [settings])

  return (
    <>
      {data && data.last_page && !!data.total && (
        <CCardFooter className="py-1">
          <CRow className="d-flex justify-content-between align-items-center">
            {!hideDisplaySummary && (
              <>
                {searchParams ? (
                  <CCol className="d-none d-md-flex">
                    <CCol xs="auto">
                      <CFormSelect
                        id="limit"
                        name="limit"
                        disabled={isLoading}
                        value={searchParams?.limit || ''}
                        onChange={handlePerPageChange}
                      >
                        {pageLimitOptions?.map((value, index) => {
                          return (
                            <option key={index + value} value={value}>
                              {value} {t('per-page')}
                            </option>
                          )
                        })}
                      </CFormSelect>
                    </CCol>
                  </CCol>
                ) : (
                  <CCol className="d-none d-xl-flex">
                    {t('records-per-page', { per_page: data?.per_page })}
                  </CCol>
                )}
                <CCol className="d-flex justify-content-lg-start">
                  {t('total-records', { from: data?.from, to: data?.to, total: data?.total })}
                </CCol>
              </>
            )}
            {!hideJumpToPage && (
              <CCol xxl="auto" className="d-none d-xxl-flex justify-content-end">
                <CForm
                  noValidate
                  onSubmit={(e) => {
                    e.preventDefault()
                    onActivePageChange(currentPage)
                  }}
                >
                  <CRow>
                    <CCol xs="auto">
                      <CFormInput
                        type="number"
                        min={1}
                        max={data?.last_page}
                        name="page"
                        onKeyDown={handleIntegerPressDown}
                        value={currentPage}
                        tooltipFeedback
                        autoComplete="off"
                        feedbackInvalid={t('invalid-page')}
                        disabled={isLoading}
                        invalid={currentPage < 1 || currentPage > data?.last_page}
                        onChange={(e) => {
                          setCurrentPage(e.target.value)
                        }}
                      />
                    </CCol>
                    <CCol xs="auto" className="ps-1">
                      <CButton
                        disabled={isLoading}
                        className="text-start"
                        type="submit"
                        color="primary"
                      >
                        {t('go')}
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCol>
            )}
            <CCol xs="auto">
              <CSmartPagination
                role="button"
                disabled={isLoading}
                size={sizeSM ? 'sm' : null}
                className={`float-end me-1 ${sizeSM ? 'pt-2' : 'pt-3'}`}
                activePage={data?.current_page}
                pages={data?.last_page}
                onActivePageChange={onActivePageChange}
              />
            </CCol>
          </CRow>
        </CCardFooter>
      )}
    </>
  )
}

export default TableFooter
